module.exports = Promise.all([parcelRequire.load("hHp3b"), parcelRequire.load("eyun8")]).then(() => parcelRequire('9Gx4h'));